module.exports = require('./globals.json');



//////////////////
// WEBPACK FOOTER
// ./~/eslint/~/globals/index.js
// module id = 1349
// module chunks = 0